import React from 'react';

const colors = ['#4A6CF7','#FF6B6B','#34C759','#FFBE0B','#FF9500','#8B5CF6','#EC4899','#14B8A6'];

function getColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return colors[Math.abs(hash) % colors.length];
}

function getInitials(name) {
  return name.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase();
}

export default function Avatar({ name = '', size = 36, src, style }) {
  if (src) return (
    <img src={src} alt={name} style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', ...style }} />
  );
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: getColor(name || 'A'),
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: '#fff', fontWeight: 700, fontSize: size * 0.36,
      flexShrink: 0, ...style
    }}>
      {getInitials(name || '?')}
    </div>
  );
}
